import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { BrowserModule, provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import Aura from '@primeng/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { HttpErrorInterceptor } from '@shared/interceptors/http-error.interceptor';
import { RefreshTokenInterceptor } from '@shared/interceptors/refresh-token.interceptor';
import { authInterceptor } from '@shared/interceptors/auth.interceptor';
export const appConfig: ApplicationConfig = {
	providers: [
		importProvidersFrom(BrowserModule, AppRoutingModule),
		provideAnimations(),
		provideClientHydration(withEventReplay()),
		provideHttpClient(withInterceptorsFromDi(), withInterceptors([authInterceptor])),
		provideAnimationsAsync(),
		providePrimeNG({
			theme: {
				preset: Aura,
				options: {
					prefix: 'wip',
					darkModeSelector: false,
					scope: 'primeng'
				}
			},
			translation: {
				firstDayOfWeek: 1,
				dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
				dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
				dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
				monthNames: [
					'Enero',
					'Febrero',
					'Marzo',
					'Abril',
					'Mayo',
					'Junio',
					'Julio',
					'Agosto',
					'Septiembre',
					'Octubre',
					'Noviembre',
					'Diciembre'
				],
				monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
				today: 'Hoy',
				clear: 'Limpiar',
				dateFormat: 'dd/mm/yy',
				weekHeader: 'Sem'
			}
		}),
		{
			provide: HTTP_INTERCEPTORS,
			useClass: RefreshTokenInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpErrorInterceptor,
			multi: true
		}
	]
};
